var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBeemgIconsFilterReset2023(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.2299 12.55C27.1199 12.27 26.8099 12.12 26.5199 12.2C26.3499 12.24 26.2199 12.35 26.1399 12.51C26.0599 12.67 26.0599 12.84 26.1199 13C27.7499 17.1 26.7799 21.74 23.6399 24.83C19.3999 28.99 12.5299 28.97 8.31991 24.78C6.25991 22.73 5.11991 19.99 5.10991 17.07C5.10991 14.15 6.23991 11.41 8.29991 9.34998C10.3299 7.31998 13.0299 6.18998 15.8999 6.15998H16.2299V8.16998L19.2499 5.68998C19.2899 5.65998 19.3099 5.61998 19.3099 5.57998C19.3099 5.53998 19.2899 5.49998 19.2499 5.46998L16.2399 2.97998L16.2299 4.96998H15.9099C12.7099 4.98998 9.70991 6.23998 7.44991 8.49998C5.16991 10.78 3.90991 13.82 3.90991 17.05C3.90991 20.28 5.16991 23.31 7.44991 25.6C9.71991 27.87 12.7399 29.13 15.9499 29.14C15.9699 29.14 15.9799 29.14 15.9999 29.14C19.3199 29.14 22.4199 27.82 24.7199 25.43C26.8999 23.16 28.0999 20.18 28.0899 17.03C28.0799 15.48 27.7899 13.97 27.2299 12.55Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeemgIconsFilterReset2023);
export default __webpack_public_path__ + "static/media/beemg-icons-filter-reset-2023.17c548212ea95c8d606bce27503e62df.svg";
export { ForwardRef as ReactComponent };